import React from 'react'
import {ILaudoAuditoria, ILaudoCapitulo, REGRAS_LAUDO_PILOTO} from '../interfaces/ILaudoAuditoria'
import {obterLabelTributo} from './AuditoriaFiltros'
import {TributoAuditoria} from '../interfaces/IAuditoria'
import {progressoRevisao} from '../utils/laudoRevisao'

interface Props {
  laudo: ILaudoAuditoria
  // Quando informado, mostra o botão "Revisar laudo" logo abaixo da barra.
  onRevisar?: () => void
}

export const rotuloCapitulo = (c: ILaudoCapitulo) =>
  REGRAS_LAUDO_PILOTO.includes(c.regra) ? obterLabelTributo(c.regra as TributoAuditoria) : c.categoria

// DEVN3-521 / AUD-REL-001 — barra de progressão da revisão do laudo. Entram as regras com
// apontamento (ERRO, ALERTA ou AVISO); cada capítulo é aceito ou recusado em /auditoria/revisao.
// A árvore global de etapas do relatório (BLOCO B / Etapa 13-15) é um épico à parte e não faz
// parte deste componente. Card de resumo no topo da área principal, mesmo padrão visual do card
// de Cartas de Circularização.
const AuditoriaLaudoBarraProgressao: React.FC<Props> = ({laudo, onRevisar}) => {
  const gerando = laudo.status === 'GERANDO'
  const p = progressoRevisao(laudo)

  const semApontamentos = !gerando && laudo.status !== 'ERRO' && p.total === 0 && p.falhas === 0
  const concluida = !gerando && p.total > 0 && p.pendentes === 0
  const mostrarResumo = !gerando && !semApontamentos && laudo.status !== 'ERRO'

  return (
    <div className='auditoria-banner-card'>
      <div className='auditoria-banner-info'>
        <h5 className='auditoria-banner-title'>
          Revisão do Laudo
          {gerando && (
            <span
              className='spinner-border spinner-border-sm ms-2'
              style={{width: 12, height: 12, borderWidth: 2}}
            />
          )}
        </h5>
        {laudo.status === 'ERRO' ? (
          <p className='auditoria-banner-subtitle text-danger mb-0'>Falha na geração</p>
        ) : (
          <p className='auditoria-banner-subtitle mb-0'>
            {gerando
              ? 'Analisando as regras de auditoria…'
              : semApontamentos
              ? '✓ Nenhum apontamento identificado neste período.'
              : 'Acompanhe o andamento da revisão desta auditoria.'}
          </p>
        )}
      </div>

      {mostrarResumo && (
        <>
          <span
            className='auditoria-banner-badge'
            style={{
              background: concluida ? '#e3f3e6' : '#fff3da',
              color: concluida ? '#2e7d32' : '#8a6d1d',
            }}
          >
            {concluida ? 'CONCLUÍDA' : 'EM REVISÃO'}
          </span>

          <div className='auditoria-banner-metric'>
            <strong>{p.pendentes}</strong>
            <span>pendente{p.pendentes === 1 ? '' : 's'}</span>
          </div>

          <div className='auditoria-banner-progress'>
            <div className='progress' style={{height: 8}}>
              <div
                className='progress-bar'
                role='progressbar'
                style={{width: `${p.pct}%`}}
                aria-valuenow={p.pct}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
            <span className='auditoria-banner-progress-pct'>{p.pct}%</span>
          </div>
        </>
      )}

      {onRevisar && (
        <button
          type='button'
          className='btn btn-outline-primary auditoria-banner-btn'
          disabled={gerando}
          onClick={onRevisar}
        >
          Revisar laudo
        </button>
      )}

      {mostrarResumo && (
        <div className='auditoria-banner-detail'>
          <span style={{fontSize: 12, color: '#47586b'}}>
            {p.aceitos} aceito{p.aceitos === 1 ? '' : 's'} · {p.recusados} recusado
            {p.recusados === 1 ? '' : 's'}
          </span>
          {p.falhas > 0 && (
            <div className='text-danger mt-1' style={{fontSize: 12, fontWeight: 700}}>
              <i className='bi bi-exclamation-triangle-fill me-1' />
              {p.falhas} com falha na geração
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default AuditoriaLaudoBarraProgressao
